/** Junta nomes de classe condicionalmente, sem dependência nova (evita clsx/classnames
 * — React/CSS já resolve isso). */
export function cx(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(' ');
}
